// 辞退時：KWANKGM04040_借入申込入力（受付完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';
import HeadingM from '../../molecules/HeadingM';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  guide_text: string;
  is_staff: boolean;
  is_loading: boolean;
}

const DeclineLoanApplication: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  guide_text,
  is_staff,
  is_loading,
}) => {
  return (
    <>
      <TopArea
        step_navigation={{ ...step_navigation, show: false }}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={false}
        guide_text={guide_text}
        display_status={false}
      />
      <HeadingM label={'借入申込辞退受付完了'} />
      <p>
        <br />
        借入申込辞退の受付を完了しました。
      </p>
      <MypageReturn is_staff={is_staff} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default DeclineLoanApplication;
